// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__24e10","copyright":"Footer_copyright__2d4ZB"};